import { Portfolio } from '../redux/reducers/portfolio'
import { fetchRequest } from '../services/http.service'

export const GET_PORTFOLIO_URL = `/portfolio/new`
export const getPortfolioRequest = (id: Number | null) =>  fetchRequest.get<Portfolio>(GET_PORTFOLIO_URL + `/${id ? id : ''}`)

